var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6667 105.333C89.8125 105.333 105.333 89.8125 105.333 70.6667C105.333 51.5208 89.8125 36 70.6667 36C51.5208 36 36 51.5208 36 70.6667C36 89.8125 51.5208 105.333 70.6667 105.333Z",
    fill: "url(#paint0_linear_25106_148198)",
    stroke: "#B2B2B2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 43.2422C85.4053 45.3165 91.2452 49.8528 95 55.8314",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.001 114.001L95.3672 95.3672",
    stroke: "#B2B2B2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4987 59.832L59.832 81.4987M59.832 59.832L81.4987 81.4987",
    stroke: "url(#paint1_linear_25106_148198)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25106_148198",
    x1: 95,
    y1: 44,
    x2: 52.5,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25106_148198",
    x1: 82.999,
    y1: 57.9988,
    x2: 57.999,
    y2: 83.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4C4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconLight);
export default __webpack_public_path__ + "static/media/searchIconLight.d42430328c4b3271cfd68f44edf63846.svg";
export { ForwardRef as ReactComponent };